var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _polygon, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _polygon2, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionPixel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7feff;}.cls-2{fill:#231e2b;}.cls-3{fill:#cf8934;}.cls-4{fill:#3b2130;}.cls-5{fill:#784028;}.cls-6{fill:#f5f38e;}.cls-7{fill:#e2b436;}.cls-8{fill:#522b29;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "caution") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 15,
    width: 12,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14,
    y: 14,
    width: 1,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 14,
    width: 12,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 14,
    width: 1,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13,
    y: 13,
    width: 1,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2,
    y: 13,
    width: 1,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 11,
    width: 1,
    height: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14,
    y: 11,
    width: 1,
    height: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8,
    y: 12,
    width: 1,
    height: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7,
    y: 12,
    width: 1,
    height: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 11,
    width: 1,
    height: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15,
    y: 11,
    width: 1,
    height: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 13,
    y: 11,
    width: 1,
    height: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13,10H12V8H11V6H10V9H9v1H7V9H6V6H5V8H4v2H3v2H2v1H3v1H13V13h1V12H13ZM7,13V11H9v2Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 8,
    y: 11,
    width: 1,
    height: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7,
    y: 11,
    width: 1,
    height: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2,
    y: 11,
    width: 1,
    height: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14,
    y: 9,
    width: 1,
    height: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 9,
    width: 1,
    height: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 9,
    width: 1,
    height: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13,
    y: 9,
    width: 1,
    height: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 12,
    y: 9,
    width: 1,
    height: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7,
    y: 9,
    width: 1,
    height: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 3,
    y: 9,
    width: 1,
    height: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13,
    y: 7,
    width: 1,
    height: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9,
    y: 8,
    width: 1,
    height: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 6,
    y: 8,
    width: 1,
    height: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3,
    y: 7,
    width: 1,
    height: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 7,
    width: 1,
    height: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12,
    y: 7,
    width: 1,
    height: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11,
    y: 7,
    width: 1,
    height: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9,
    y: 7,
    width: 1,
    height: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "9 6 6 6 6 8 7 8 7 9 8 9 8 10 9 10 9 6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 4,
    y: 7,
    width: 1,
    height: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12,
    y: 5,
    width: 1,
    height: 2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9,
    y: 6,
    width: 1,
    height: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4,
    y: 5,
    width: 1,
    height: 2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 5,
    width: 1,
    height: 2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 5,
    width: 1,
    height: 2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 10,
    y: 5,
    width: 1,
    height: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 7,
    y: 5,
    width: 2,
    height: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "7 6 7 5 9 5 9 6 10 6 10 4 9 4 9 3 7 3 7 4 6 4 6 6 7 6"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5,
    y: 5,
    width: 1,
    height: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11,
    y: 3,
    width: 1,
    height: 2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 3,
    width: 1,
    height: 2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 3,
    width: 1,
    height: 2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10,
    y: 3,
    width: 1,
    height: 2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 9,
    y: 3,
    width: 1,
    height: 1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 6,
    y: 3,
    width: 1,
    height: 1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10,
    y: 2,
    width: 1,
    height: 1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9,
    y: 2,
    width: 1,
    height: 1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7,
    y: 2,
    width: 2,
    height: 1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6,
    y: 2,
    width: 1,
    height: 1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5,
    y: 2,
    width: 1,
    height: 1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 1,
    width: 1,
    height: 1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 1,
    width: 2,
    height: 1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6,
    y: 1,
    width: 1,
    height: 1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    width: 2,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionPixel);
export default __webpack_public_path__ + "static/media/cautionPixel.9a659a8ef29c29e5cec360c61c16aa63.svg";
export { ForwardRef as ReactComponent };